import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { LoginSuccessAction, LogoutAction } from '../action/auth.action';
import { ApplicationState } from '../../../reducers';

@Injectable()
export class AuthEffects {
  constructor(private readonly action$: Actions, private readonly router: Router, private readonly store: Store<ApplicationState>) {}

  navigateToAppPage$ = createEffect(
    () =>
      this.action$.pipe(
        ofType(LoginSuccessAction),
        tap((_action) => {
          // console.log('login success');
          // this.router.navigate(['/app']);
        }),
      ),
    { dispatch: false },
  );

  navigateToLoginPage$ = createEffect(
    () =>
      this.action$.pipe(
        ofType(LogoutAction),
        tap((_action) => {
          this.router.navigate(['/login']);
        }),
      ),
    { dispatch: false },
  );
}
